import CollectionPost from "./collection-post";

export default CollectionPost;